export const getEmojiMart = () =>
  import(/* webpackChunkName: "Emoji_Mart" */ "emoji-mart");
